import { api, BACKEND_URL } from "./api";

const KEY = "lif_market_token";
export const marketToken = () => localStorage.getItem(KEY) || "";
export const setMarketToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
const cfg = (c = {}) => ({ ...c, headers: { ...(c.headers || {}), ...(marketToken() ? { "X-Market-Token": marketToken() } : {}) } });

export const mk = {
  get: (u, c) => api.get(u, cfg(c)),
  post: (u, d, c) => api.post(u, d, cfg(c)),
  patch: (u, d, c) => api.patch(u, d, cfg(c)),
  delete: (u, c) => api.delete(u, cfg(c)),
};

export const photoUrl = (p) => (p ? `${BACKEND_URL}/api/files/${p}` : "");
export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: Number(n || 0) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
export const priceLabel = (l) => (l.kind === "free" ? "Free" : l.kind === "rental" ? `${money(l.price)} / ${l.rental_period}` : money(l.price));
